import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/services/backup-and-ransomware-defense/BackupAssessmentScrollHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/HeroEntrance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/ScrollReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InteractiveRansomwareResilienceAssessment"] */ "/opt/buildhome/repo/components/tools/irra/InteractiveRansomwareResilienceAssessment.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
